module.exports = {
  // 生成表单
  templateDownload: 'templateDownload',
  // 生成表单
  generateForm: 'generateForm',
  // 录入
  input: 'input',
  // 点击上传
  clickToUpload: 'Click To Upload',
  // 选择用户
  selectUser: 'Select User',
  // 生成数据
  generateData: 'generateData',
  // 同步数据库
  synchronizeDatabase: 'synchronizeDatabase',
  // 功能测试
  functionTest: 'functionTest',
  // 配置地址
  configureAddress: 'configureAddress',
  // 权限控制
  accessControl: 'accessControl',
  // 角色授权
  roleAuthorization: 'roleAuthorization',
  // 生成视图
  generateView: 'generateView',
  // 视图管理
  viewManagement: 'viewManagement',
  // 移除
  remove: 'remove',
  // 更换
  replace: 'replace',
  // JS增强
  jsEnhancement: 'jsEnhancement',
  // SQL增强
  sqlEnhancement: 'sqlEnhancement',
  // JAVA增强
  javaEnhancement: 'javaEnhancement',
  // 导入数据库表
  importDatabaseTable: 'importDatabaseTable',
  // 代码生成
  codeGeneration: 'codeGeneration',
  // 生成测试数据
  generateTestData: 'generateTestData',
  // 自定义按钮
  customButton: 'customButton',
  selectFile: 'Select File', // 选择文件
  executeImmediately: 'execute Immediately', //立即执行
  zidianpeizhi: 'Dict Config', //字典配置
  confirm: 'confirm', // 确定
  search: 'search', // 查询
  reset: 'reset', // 重置
  add: 'add', // 新增
  import: 'import', // 导入
  detailImport: 'Detail Upload',//明细导入
  quickInput: 'Quickly Input',//快读录入
  export: 'export', // 导出
  edit: 'edit', // 编辑
  more: 'more', // 更多
  delete: 'delete', // 删除
  clear: 'clear', // 清空
  batchOperation: 'batch operation', // 批量操作
  cancel: 'cancel', // 取消
  details: 'details', // 详情
  password: 'password',//密码
  frozen: 'frozen',//冻结
  thaw:'thaw',//解冻
  submit: 'submit', // 提交
  writeOff: 'write off', // 冲销
  synchronize: 'synchronize', // 同步
  print: 'print', // 打印
  save: 'save', // 保存
  close: 'close', // 关闭
  select: 'select', // 选择
  addByReference: 'Add by reference', // 参照新增
  orderSelection: 'Order selection', // 选单
  initializeImport: 'Initialize import', // 初始化导入
  forDetailsPlease: 'For details, please', // 具体详情请
  clickToDownload: 'Click to download', // 点击下载
  logOut: 'Log out', // 退出登录
  enable: 'Enable', // 启用
  disable: 'Disable', // 禁用
  extractionCompanyDetails: 'Extraction company details', // 提取明细
  addCompany: 'Add Company', // 添加公司
  addSubordinate: 'Add Subordinate', // 添加下级
  releaseVersion: 'Release Version', // 发布版本
  batchDelete: 'Batch delete', // 批量删除
  treeOperations: 'Tree Operations', // 树操作
  FatherSonConnection: 'Father-Son Connection', // 父子关联
  cancelConnection: 'Cancel connection', // 取消关联
  selectAll: 'Select All', // 全部勾选
  unselectAll: 'Unselect All', // 取消全选
  expandAll: 'Expand all', // 展开所有
  mergeAll: 'Merge all', // 合并所有
  newRole: 'New Role', // 新建角色
  newDepartRole: 'new Depart Role', // 新建部门角色
  clearSelection: 'Clear Selection', // 清空选择
  batchRestore: 'Batch Restore', // 批量还原
  restoreUser: 'Restore User',// 还原用户
  deleteCompletely: 'Delete completely',// 彻底删除
  existingUsers: 'Existing users', // 已有用户
  authorization: 'Authorization', // 授权
  saveOnly: 'Save only',// 仅保存
  saveAndClose: 'Save and close',// 保存并关闭
  dataRules: 'Data Rules', // 数据规则
  approve: 'approve',//审批
  turnDown: 'turn down',//驳回
  void: 'void',//作废
  approval: 'Approval',//审批
  voided: 'Voided',//作废
  copy: 'Copy',//复制
  rejected: 'Rejected',//驳回
  reviewApproved: 'Review approved',//审核通过
  sync: 'Sync',//同步
  update: 'Update',//更新
  withdraw: 'Withdraw',//撤回
  synchronousUpdate: 'Synchronous update',//同步更新
  statistics: 'total',//统计
  drawDownContractPriceList: 'Draw down contract price list',//提取合同价格清单
  newFarm: 'New farm',//新增养殖场
  detailImport: 'Detail import',//明细导入
  refreshTheCache: 'Refresh the cache',//刷新缓存
  recycleBin: 'Recycle Bin',//回收站
  customQuery: 'Custom Query',//高级查询
  notice: 'notice',//通知
  systemMessage: 'System Message',//系统消息
  seeMore: 'See More',//查看更多
  next: 'Next',//下一步
  previous: 'Previous',//上一步
  execute: 'Execute',//执行
  release: 'release',//发布
  revoke: 'revoke',//撤销
  see: 'see'//查看
}